import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {ProTable} from "@/widget/ProTable/ProTable";
import {MonitorPageBO, MonitorPageVO, useQueryMonitorPage} from "@/service/monitor.s";
import {formatTime, stringAvatar} from "@/helper/method";
import {Avatar} from "@mui/material";
import Typography from "@mui/material/Typography";
import {ViewMonitor} from "@/pages/Patent/ViewMonitor";
import {permScope, roleAlias} from "@/helper/constant";
import {useAuthInfo} from "@/store/account.c";

export const MonitorListPage = () => {
    const {
        mutate: monitorPageMutate,
        data: monitorPageData,
        isPending: monitorPagePending,
    } = useQueryMonitorPage()
    const {role: {dataScope, roleAlias: alias}} = useAuthInfo()

    const columns: GridColDef<MonitorPageVO>[] = [
        {field: "patentName", headerName: "专利名称", flex: 0.6, valueFormatter: value => value || "待定"},
        {field: "category", headerName: "申请类型", flex: 0.4, valueFormatter: value => value || "待定"},
        {field: "applyNo", headerName: "申请号/专利号", headerAlign: 'center', align: 'center', flex: 0.5},
        {field: "applyDate", headerName: "申请时间", headerAlign: 'center', align: 'center', flex: 0.4, valueFormatter: value => formatTime("D", value) || "-"},
        {field: "customerName", headerName: "客户名称", flex: 0.5},
        {
            field: "seller",
            headerName: "业务人员",
            flex: 0.35,
            align: "center",
            display: 'flex',
            headerAlign: "center",
            renderCell: ({row}) => <Avatar {...stringAvatar(row.seller)} />
        },
        {
            field: "feeType",
            headerName: "费用名称",
            flex: 0.5,
        },
        {
            field: "deadline",
            headerName: "最后期限",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            display: 'flex',
            renderCell: ({row}) => <Typography color={'warning'}>{formatTime("D", row.deadline)}</Typography>
        },
        {field: "amount", headerName: "金额", headerAlign: 'center', align: 'center', flex: 0.3},
        {
            field: "paymentStatus", headerName: "是否缴费", headerAlign: 'center', align: 'center', flex: 0.4,
            display: 'flex',
            renderCell: ({row}) => <Typography color={row.paymentStatus == 1 ? 'success' : 'error'}>{row.paymentStatus == 1 ? '已缴费' : "未缴费"}</Typography>
        },
    ];

    return (
        <ProTable<MonitorPageVO>
            loading={monitorPagePending}
            columnVisibilityModel={{
                seller: !(alias == roleAlias["marketing"] && dataScope == permScope['self'])
            }}
            showSearch={true}
            columns={columns}
            renderDrawer={{view: <ViewMonitor/>}}
            data={monitorPageData?.data}
            onSearch={(params: MonitorPageBO) => {
                monitorPageMutate(params);
            }}
            drawerProps={{
                view: {
                    hiddenFooter: true,
                }
            }}
            code={"patent_monitor"}
        />
    );
};
